import { Box, Avatar, useTheme } from '@mui/material';
import CustomStoryImageWithDefault from '@/components/shared/custom/CustomStoryImageWithDefault';
import LottieIconComponent from '@/DesignSystem/features/lottie/LottieIconComponent';
import { LOTTIE_ICONS } from '@/DesignSystem/features/lottie/lottie-icons';
import CustomTooltip from '@/DesignSystem/components/tooltip/CustomTooltip';

const StoryItem = ({ story, isViewed, onClick, size }) => {
    const theme = useTheme();

    if (!story || (!story.playerId && !story.teamId && !story.image)) {
        return null;
    }

    return (
        <CustomTooltip label={story.title || 'Story'}>
            <Box
                onClick={onClick}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    cursor: 'pointer',
                    minWidth: size,
                    flexShrink: 0, // Evitar que se compriman en mobile
                    position: 'relative',
                }}
            >
                {isViewed ? (
                    <Avatar
                        src={story.image}
                        alt={story.title || 'Story'}
                        sx={{
                            width: size,
                            height: size,
                            border: `1px solid ${theme.palette.border.main}`,
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                transform: 'scale(1.05)',
                            },
                        }}
                    />
                ) : (
                    <Box
                        sx={{
                            width: size,
                            height: size,
                            borderRadius: '50%',
                            padding: '2px',
                            background: 'linear-gradient(45deg, #2196F3, #E91E63)',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                transform: 'scale(1.05)',
                            },
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                height: '100%',
                                borderRadius: '50%',
                                overflow: 'hidden',
                                backgroundColor: 'transparent',
                            }}
                        >
                            <CustomStoryImageWithDefault
                                src={story.image}
                                alt={story.title || 'Story'}
                                width={size}
                                height={size}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    background: theme.palette.background.default,
                                }}
                            />
                        </Box>
                    </Box>
                )}
                {story.isHot && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            zIndex: 1,
                        }}
                    >
                        <LottieIconComponent icon={LOTTIE_ICONS.FIRE} width={24} height={24} />
                    </Box>
                )}
            </Box>
        </CustomTooltip>
    );
};

export default StoryItem;
